import React from "react";

const AboutUS = () => {
  return (
    <div className="aboutus">
      <div className="aboutus-overlay"></div>
      <div className="aboutus-content">
        <h1>About Us</h1>

        <h3>Who We Are?</h3>
        <p>
          At <span>RG Fitness</span>, we believe that fitness is not just about
          building muscles; it's about building a healthier and happier life.
          Established with a passion for fitness and wellness, RG Fitness is
          your ultimate destination to achieve your health and fitness goals in
          a supportive and motivating environment.
        </p>
        <p>
          Our gym is owned by <span>Ratnesh Gupta</span>, run by{" "}
          <span>Mithilesh Gupta</span>, and led by trainer <span>Shiv Verma</span>,
          a dedicated fitness enthusiast and visionary who has spent years
          inspiring individuals to transform their lives through the power of
          exercise and discipline. Under his guidance, <span>RG Fitness</span>{" "}
          has become a hub for people of all fitness levels—whether you're a
          beginner taking the first step or an athlete striving for peak
          performance.
        </p>

        <h3>What We Offer</h3>
        <ul>
          <li>✅ Fully equipped weight training and cardio zone</li>
          <li>✅ Personal training & customized workout plans</li>
          <li>✅ Diet & nutrition counseling</li>
          <li>✅ AC environment & clean changing rooms</li>
        </ul>

        <h3>Why Choose RG Fitness?</h3>
        <p>
          We’re not just a gym—we’re a <strong>community</strong>. Our team of
          certified trainers, our safe and friendly environment, and our
          dedication to your success makes us the go-to gym in the area.
        </p>

        <h3>Join the RGFitness Family</h3>
        <p>
          Whether you're chasing physical gains, mental peace, or overall wellness—
          <strong>RGFitness is where your journey begins</strong>. Let’s get stronger, together.
        </p>

        <blockquote>
          “You don’t have to be extreme, just consistent.” 💪
        </blockquote>
      </div>
    </div>
  );
};

export default AboutUS;
